
import PropTypes from 'prop-types'
import React from 'react'

const Check = props => {
  const style = {
    width: 14,
    height: 11,
    marginRight: 9,
    display: 'inline'
  }

  return (
    <div style={style} className={props.class}>
      <svg width='14' height='11' viewBox='-1 7 14 11' xmlns='http://www.w3.org/2000/svg'>
        <path stroke='#FFF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' fill='none' d='M0 13.957l4.238 2.947L11.487 8' />
      </svg>
    </div>
  )
}

Check.propTypes = {
  class: PropTypes.string
}

Check.displayName = 'Check'

export default Check



// WEBPACK FOOTER //
// ./ui/icons/check.js